import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Bmw = ({featuredProjectsList}) => {
  const project = getProject('bmw');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '216713828'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            With a legacy platform and over 10k pages, BMWUSA.com was in dire
            need of a modern website with fast content publishing capabilities.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170506014808/bmw-slide0.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="from-the-bottom-up">From the bottom up</h2>
          <p>
            Built on the Adobe Experience Manager platform using a component
            library with 50+ customizable page templates, allows content to be
            composed on any page, in any configuration:
          </p>
          <ul>
            <li>
              Enables BMW editorial staff to work faster and evolve the website
              for years to come.
            </li>
            <li>
              Authors can create anything from contextual forms to the dealer
              locator and customizable special offers.
            </li>
          </ul>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170506014810/bmw-slide1.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170506014811/bmw-slide2.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170506014812/bmw-slide3.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>
              A truly dynamic content authoring experience with few limits that
              empowers the BMW team to launch products and offerings on the go.
            </li>
            <li>
              Site-wide responsive components utilize resolution specific
              imagery and typography in order to serve a user optimized
              experience.
            </li>
            <li>JD Power Award - Highest Ranked Automotive Website.</li>
          </ul>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>KBS</p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: ['Prototyping & Validation', 'Technical Strategy']
              },

              {
                title: 'Technology',
                items: [
                  'Content Management System',
                  'Front-end Development',
                  'Functional Prototyping',
                  'Systems Architecture'
                ]
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://bmwusa.com/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Bmw;
